export default "__VITE_ASSET__DQDay0e___"